export function switchGenderByName(name, currentDriver){
    console.log(name);
    const f = 'Female';
    const m = 'Male'
    switch(name.toLowerCase()){
        case 'hien':
            return m;
        case 'william':
            return m;
        case 'gloria':
            return f;
        default:
            return currentDriver.gender.genderPrimarySource;
    }
}

export function returnEducation(name) {
    switch(name.toLowerCase()){
        case 'hien':
            return 'HSDG';
        case 'william':
            return 'PH.D.';
        case 'gloria':
            return 'MBA';
        default:
            return 'BA';
    }
}

export function returnOccupation(name) {
    switch(name.toLowerCase()){
        case 'hien':
            return 'Landscaper';
        case 'william':
            return 'Pediatrician';
        case 'gloria':
            return 'Teacher';
        default:
            return 'Web Designer';
    }
}


// WEBPACK FOOTER //
// ./src/utils/updateDriverInfo.js